import { useNavigate } from "react-router-dom";


const Footer = () => {
    const navigate = useNavigate();

    return (
        <div className='footer'>
                <p onClick={() => navigate('/about')}>About</p>
                <p onClick={() => navigate('/terms')}>Terms</p>
              
            </div>
    )
}

export default Footer;